import { Module } from 'vuex';
import type { IAppGlobalRoleWithAllowDeny, IAppCustomerRoleWithAllowDeny } from '@license-manager/types';
import $http from '../services/api';
import { get, uniqBy } from 'lodash';



export const approles: Module<any, any> = {
  namespaced: true,
  state: {
    customerRoles: {} as { [customerId: number]: IAppCustomerRoleWithAllowDeny[] },
    globalRoles: [] as IAppGlobalRoleWithAllowDeny[],
    allRoles: [] as (IAppGlobalRoleWithAllowDeny | IAppCustomerRoleWithAllowDeny)[],
    loading: false
  },

  actions: {
    async loadRoles({ commit, state },
      { includeRights, loadAllRoles, customerId, loadGlobalRoles, loadNames }:
        { includeRights: boolean, loadAllRoles: boolean, customerId?: number, loadGlobalRoles?: boolean, loadNames?: boolean }) {
      commit('setLoading', true);
      try {
        const response = await $http.get(`/approlesrights/roles${customerId ? `?customerId=${customerId}` : ''}`, { params: { includeRights, loadAllRoles, loadNames } });
        if (customerId) {
          commit('setCustomerRoles', { customerId, roles: response.data });
        } else if (loadAllRoles) {
          commit('allRoles', response.data);
        } else if (loadGlobalRoles) {
          commit('setGlobalRoles', response.data);
        }
      } catch (error) {
        console.error('Fehler beim Laden der Rollen:', error);
        throw error;
      } finally {
        commit('setLoading', false);
      }
    }
  },

  mutations: {
    setCustomerRoles(state, { customerId, roles }) {
      state.customerRoles = {
        ...state.customerRoles,
        [customerId]: roles
      };
    },
    setGlobalRoles(state, roles) {
      state.globalRoles = roles;
    },
    allRoles(state, roles) {
      state.allRoles = roles;
    },
    setLoading(state, loading) {
      state.loading = loading;
    }
  },

  getters: {
    getCustomerRoles: (state) => (customerId: number) => {
      return state.customerRoles[customerId] || [];
    },
    getGlobalRoles: (state) => () => {
      return state.globalRoles;
    },
    getAllRoles: (state) => (customerId?: number) => {
      if (!customerId) {
        // remove duplicates
        return uniqBy(state.allRoles, 'id');
      }
      const customerRoles = state.customerRoles[customerId] || [];

      // Kombiniere globale und kundensgetRoleNamepezifische Rollen
      return [...customerRoles];
    }
  }
};
